export const HEADER_STEPS = [
  {
    step: 1,
    title: 'Enter your URL',
  },
  {
    step: 2,
    title: 'Review Report',
  },
  {
    step: 3,
    title: 'Schedule a Demo',
  },
  {
    step: 4,
    title: 'Claim your Leads',
  },
];

export const BOOK_DEMO_NON_ENTERPRISE =
  'https://calendly.com/mobilemonkey-sales/setup-call';
export const BOOK_DEMO_ENTERPRISE =
  'https://calendly.com/mobilemonkey-sales/ent-ai-demo';
export const BOOK_NON_SQL_DISCO_CALL =
  'https://calendly.com/mobilemonkey-sales/customers-ai-x-ray-demo';

// tslint:disable-next-line: max-line-length
export const LLR_DEMO_UTM = (websiteURL: string) =>
  `utm_source=${websiteURL}_LLR&utm_medium=onboarding&utm_campaign=sqlsetupcall&background_color=f7f9fd&primary_color=234f68`;
export const IN_APP_DEMO_UTM =
  'utm_source=inproduct&utm_medium=onboarding&utm_campaign=sqlsetupcall&background_color=f7f9fd&primary_color=234f68';
export const ENTERPRISE_TRAFFIC_THRESHOLD = 99999;

export const AVERAGE_WEB_CONVERSION_RATE = 0.02;
export const WEB_TRAFFIC_GROWTH_WITH_MOBILEMONKEY = 0.2;
export const AVERAGE_WEB_TRAFFIC_GROWTH =
  WEB_TRAFFIC_GROWTH_WITH_MOBILEMONKEY - AVERAGE_WEB_CONVERSION_RATE;
export const MAX_TRAFFIC_THRESHOLD = 25000;
export const MAX_LOST_LEADS_THRESHOLD = 50;
export const REDUCE_COST_PER_LEAD = 6.67;
export const SPLIT_NUMBER_BY_THOUTHANDS = /\B(?=(\d{3})+(?!\d))/g;
export const DOMAIN_WITH_PROTOCOLS_REGEX =
  /^(?:https?:\/\/)?(?:[^@\/\n]+@)?(?:www\.)?([^:\/?\n]+)/gim;

export const PROTOCOLS_IN_URL = /(^\w+:|^)\/\//;

export const beautifyNumber = (num: any, toFixed: number = 0) => {
  if (typeof num === 'number') {
    return num.toFixed(toFixed).replace(SPLIT_NUMBER_BY_THOUTHANDS, ',');
  }
  return num;
};

export const extractDomainName = (URL: string) => {
  return URL.replace('/report/', '')
    .replace('/welcome/', '')
    .match(DOMAIN_WITH_PROTOCOLS_REGEX)?.[0]
    .replace(PROTOCOLS_IN_URL, '')
    .replace('www.', '')
    .split('%2')?.[0];
};

export const usCountryCode = 'US';
